import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import TableContainer from 'components/TableContainer';
import Vocabulary from 'components/Vocabulary';
import ModalUtil from 'utils/modalUtil';
import AlertsAPI from 'restAPI/AlertsAPI';
import { useEffect } from 'react';
import ProductSubproductLevelPopup from './ProductSubproductSettingPopup';
import { SNOOZE_OPTIONS } from 'constants/NotificationConstants';
import ActionMenuV2 from 'components/ActionMenuV2';
import { PermissionSetMap } from 'constants/RBACConstants';
import AuthorisedContainer from 'components/AuthorisedContainer';
import message from 'components/CustomMessage';

const ProductSubproductLevelSettings = ({toolName}) => {
    const [data, setData] = useState(null);

    const fetchData = useCallback(async () => {
        setData(null);
        try{
            const data = await AlertsAPI.getproductSubproductToolConfig(toolName).promise;
            setData(data?.content);
        } catch (err) {
            console.log(err);
        }
    }, [toolName])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    const showToolSettingsPopup = (data) => {
        ModalUtil.show({
            content: <ProductSubproductLevelPopup toolName={toolName} configData={data} updateData={fetchData} />
        })
    }

    const onDelete = (id) => {
        const { promise } = AlertsAPI.deleteProductSubproductToolConfig(id)
        promise.then(() => {
        message.success('Configuration deleted successfully.');
        fetchData();
        })
        return promise
    }

    const onActionClick = async (name, record) => {
        switch(record.name) {
            case "edit":
                showToolSettingsPopup(record.data)
                break;
            case "delete":
                await onDelete(record.data?.id)
                break;
            default:
                break;
        }
    }

    const columns = [{
        title: "Frequency for checking scans",
        dataIndex: "interval",
        render: (data) => SNOOZE_OPTIONS.find(({value}) => value === data)?.label || "N/A"
    }, 
    // {
    //     title: "Start Date",
    //     dataIndex: "fromDate",
    //     render: CellRenderers.DATE
    // }, {
    //     title: "End Date",
    //     dataIndex: "toDate",
    //     render: CellRenderers.DATE
    // } ,
    {
        title: <Vocabulary name="product" />,
        dataIndex: "productName",
    }, {
        title: <Vocabulary name="subProduct" />,
        dataIndex: "subProductName",
    }, {
        title: "Environment",
        dataIndex: "environmentName",
    }, {
        title: "Action",
        dataIndex: "id",
        width: 30,
        render: (id, record) => <ActionMenuV2 items={actionItems} onClick={onActionClick} data={record} />
    }]

    return(
        <TableContainer 
            columns={columns}
            dataSource={data}
            loading={!Boolean(data)}
            extras={<AuthorisedContainer permission={PermissionSetMap.CREATE_SLA}><Button type="primary" size="small" onClick={() => showToolSettingsPopup()} >Add</Button></AuthorisedContainer>}
        />
    )
}

export default ProductSubproductLevelSettings;

const actionItems = [{
    type: "edit",
    permission: PermissionSetMap.UPDATE_SLA
}, {
    type: "delete",
    permission: PermissionSetMap.DELETE_SLA
}]